import { queueGroupsAccessKeySegment } from 'consts';

export const queryKey = {
  document: (documentId: number) => ['workflow-documents', { documentId }],
  // Full workflow read key. Owns the { hasGroupsAccess } segment so the read
  // hook, the post-save refetch and ensureQueryData all share one shape — if
  // these drift, ensureQueryData stops matching the mounted observer and the
  // post-save model.reset() gets stale/empty data (the PER-3423 cache-miss bug).
  // The segment is built by the shared queueGroupsAccessKeySegment so it cannot
  // drift from the document-queue chain.
  documentWorkflow: (documentId: number, hasGroupsAccess: boolean) => [
    'workflow-documents',
    { documentId },
    queueGroupsAccessKeySegment(hasGroupsAccess),
  ],
  documentQueue: (documentId: number) => [
    'workflow-documents-queue',
    { documentId },
  ],
  organisationBoardsQueue: (organisation: number, board: number) => [
    'workflow-organisation-boards-queue',
    { organisation, board },
  ],
};
